<template>
  <SogFlexRow style="justify-content: flex-start;min-height: 30px">
    <SogRadioButton
      v-for="item in items"
      :key="item.label"
      v-model="_model"
      :value="item.value"
      :label="item.label"
      :name="name"
    />
  </SogFlexRow>
</template>

<script setup lang="ts">
import {ref, watch} from "vue";
import SogRadioButtonGroupItem from "@/shared/ui/types/SogRadioButtonGroupItem";
import SogRadioButton from "@/shared/ui/SogRadioButton.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";

interface Props {
  items: SogRadioButtonGroupItem[],
  modelValue?: string,
  name?: string
}

const props = withDefaults(defineProps<Props>(), {modelValue: undefined, name: undefined}
)
const emit = defineEmits(['update:modelValue'])


const _model = ref(props.modelValue)


watch(_model, (newValue) => {
  emit('update:modelValue', newValue)
})


</script>

<style scoped>

</style>
